import {
	HStack,
	Box,
	Icon,
	Text,
	Tooltip,
	useToast,
	Grid,
	GridItem,
	Flex,
	CircularProgress,
	CircularProgressLabel,
	Image,
	IconButton,
} from '@chakra-ui/react'
import React, { useState, useEffect } from 'react'
import { FiCopy } from 'react-icons/fi'
import { MdDateRange, MdTimelapse, MdAccessTime } from 'react-icons/md'
import { CiClock2 } from 'react-icons/ci'
import { IoIosArrowForward } from 'react-icons/io'
import Card from '../../card'
import { format } from 'date-fns'
import { toSnakeCase } from '../../../utils/common.util'
import { useAuthContext } from './../../../context/auth.context'
import { useLanguageContext } from '../../../context/locale.context'
import Tappable from 'react-tappable'
import {
	dataLayerTagManager,
	eventLabelTrack,
	GA_CATEGORY_FILES,
	sectionDetailedTrack,
} from './../../../containers/repository/repo.utils'
import { BsInfoCircle } from 'react-icons/bs'
import { ActivityListItem } from '../../globalComponents/activityListItem'

const Activity = ({
	activity,
	selectedActivity,
	onSelect,
	loadChildOrders,
	selectedQueue,
	selectedFilter,
	selectedActivities = [],
	searchQuery = '',
	openParticipants = () => null,
}) => {
	const toast = useToast({
		duration: 1000,
	})
	const {
		activity_lead_operating_asset_first_name,
		activity_title,
		operating_asset_first_name,
		activity_type_category_name,
		activity_type_name,
		activity_status_name,
		activity_cuid_1,
		activity_cuid_2,
		activity_cuid_3,
		account_name,
		activity_datetime_created,
		activity_datetime_start_expected,
		activity_datetime_end_deferred,
		activity_datetime_end_status,
		asset_unread_updates_count,
		asset_unread_mention_count,
		activity_workflow_completion_percentage: completion,
		activity_sub_type_id,
		activity_creator_operating_asset_first_name,
		activity_datetime_last_updated,
		participant_list,
		activity_id,
		activity_lead_asset_id,
		activity_rag_status_name,
		activity_priority_enabled,
	} = activity

	const partInfo = {
		activity_id,
		activity_lead_asset_id,
		activity_title,
	}

	const {
		state: { authData },
	} = useAuthContext()
	const {
		state: { locale },
	} = useLanguageContext()

	const loadUserName = name => {
		if (name) {
			let nameArray = name?.split(' ')
			if (nameArray.length > 1) {
				return `${nameArray[0]} ${
					nameArray[1] && nameArray[1][0].toUpperCase()
				}.`
			} else if (nameArray.length > 0) {
				return `${nameArray[0]}.`
			}
		}
		return ''
	}

	if (selectedFilter && Object.keys(selectedFilter).length) {
		return (
			<Card
				className={'activity-card'}
				boxShadow='md'
				borderRadius='md'
				p={2}
				maxW='300px'
				bg={
					!!selectedActivity &&
					selectedActivity.activity_id === activity.activity_id
						? 'white'
						: 'secondary'
				}
				border={
					!!selectedActivity &&
					selectedActivity.activity_id === activity.activity_id
						? '1px'
						: 'none'
				}
				borderColor='green.500'
				_hover={{
					boxShadow: 'lg',
				}}
				cursor='not-allowed'
			>
				<Tooltip title={activity_title}>
					<Box
						className={`activity-card-title-${toSnakeCase(activity_title)}`}
						fontWeight='500'
						fontSize='16px'
						mb={1}
						textOverflow='ellipsis'
						color='brand.900'
					>
						<HStack justifyContent='space-between'>
							<Text as='span'>
								<Text as='span' textTransform='capitalize'>
									{activity_title}
								</Text>
								<Icon
									as={FiCopy}
									onClick={e => {
										sectionDetailedTrack({
											category: GA_CATEGORY_FILES,
											action: 'Activity',
											label: 'Activity Title Copied',
										})
										dataLayerTagManager('button_click', {
											viewName: 'Workflow List',
											buttonName: 'Activity Title Copy',
										})
										navigator.clipboard.writeText(activity_title)
										e.stopPropagation()
										toast({
											title: 'Copied!',
											status: 'success',
										})
									}}
									w={4}
									h={4}
								/>
							</Text>
							<IconButton
								bg='white'
								aria-label='close'
								size='sm'
								borderRadius='md'
								zIndex='1000'
								boxShadow='md'
								_focus={{
									bg: 'secondary',
								}}
								_hover={{
									bg: 'secondary',
								}}
								icon={
									<Icon
										className={`field-item-info-icon`}
										as={BsInfoCircle}
										w={4}
										h={4}
									/>
								}
								onClick={e => {
									openParticipants(partInfo)
									e.stopPropagation()
								}}
							/>
						</HStack>
					</Box>
				</Tooltip>
				{activity_type_name && (
					<Text
						mb={1}
						fontSize='12px'
						className={'activity-card-category-name'}
					>
						{locale['Type']} : <Text as='span'>{activity_type_name}</Text>
					</Text>
				)}
				{activity_cuid_1 && (
					<Text mb={1} fontSize='12px'>
						{locale['CUID 1']}: <Text as='span'>{activity_cuid_1}</Text>{' '}
						<Icon
							as={FiCopy}
							onClick={e => {
								sectionDetailedTrack({
									category: GA_CATEGORY_FILES,
									action: 'Activity',
									label: 'CUID 1 Copied',
								})
								dataLayerTagManager('button_click', {
									viewName: 'Workflow List',
									buttonName: 'CUID 1 Copy',
								})
								navigator.clipboard.writeText(activity_cuid_1)
								e.stopPropagation()
								toast({
									title: 'Copied!',
									status: 'success',
								})
							}}
							w={4}
							h={4}
						/>{' '}
					</Text>
				)}
				{activity_cuid_2 && (
					<Text mb={1} fontSize='12px'>
						{locale['CUID 2']} : <Text as='span'>{activity_cuid_2}</Text>
					</Text>
				)}
				{activity_cuid_3 && (
					<Text mb={1} fontSize='12px'>
						{locale['CUID 3']} : <Text as='span'>{activity_cuid_3}</Text>
					</Text>
				)}
				{account_name && (
					<Text mb={1} fontSize='12px'>
						{locale['Circle']} : <Text as='span'>{account_name}</Text>
					</Text>
				)}
				<Text mb={1} fontSize='12px'>
					{locale['Creator']} :{' '}
					<Text as='span'>
						{loadUserName(activity_creator_operating_asset_first_name)}
					</Text>
				</Text>
			</Card>
		)
	}

	return (
		<>
			<Tappable style={{ width: '100%' }}>
				<ActivityListItem
					selectedActivity={selectedActivity}
					onSelect={onSelect}
					selectedActivities={selectedActivities}
					activity={activity}
				/>
			</Tappable>
		</>
	)
}

export default Activity
